import Script from 'next/script';

import css from './respondent-panel.css';

export const RespondentPanel: FC = () => {
    return (
        <div className={css.respondentPanel}>
            <h1>Панели респондентов Тестограф — подбор целевой аудитории под задачу исследования</h1>
            <p>
                Тестограф сотрудничает с различными панелями респондентов и рекрутинговыми партнёрами в России и странах
                СНГ. Это позволяет подбирать целевую аудиторию под конкретные задачи исследования — от массовых
                потребительских сегментов до более узких групп с заданными характеристиками. Мы не ограничены одной
                базой респондентов и подбираем источники под требования исследования, в том числе и через методику River
                Sampling: по профилю аудитории, объёму выборки и срокам. Стоимость и сроки сбора рассчитываются
                индивидуально — с учётом параметров аудитории, количества ответов и длины анкеты.
            </p>
            <h3 className={css.contentTitle}>Заявка на расчёт стоимости</h3>
            <div id='tte-i-686703'></div>

            <p className={css.bold}>Как рассчитывается стоимость сбора респондентов</p>
            <p>Стоимость формируется индивидуально под каждый проект. При расчёте учитываются:</p>
            <p>- требования к целевой аудитории,</p>
            <p>- количество необходимых ответов,</p>
            <p>- длина и сложность анкеты,</p>
            <p>- желаемые сроки проведения исследования.</p>
            <p>
                После отправки заявки мы анализируем задачу, подбираем подходящие панели респондентов и возвращаем
                прозрачный расчёт бюджета и сроков сбора данных.
            </p>
            <p className={css.bold}>Как запускается сбор респондентов</p>
            <p>Запуск исследования с привлечением панелей респондентов проходит в несколько этапов:</p>
            <p>
                <span className={css.bold}>1. Описание задачи:</span> Вы описываете цель исследования, параметры
                аудитории, объём выборки и сроки. Это можно сделать через форму заявки или при общении с менеджером.
            </p>
            <p>
                <span className={css.bold}>2. Подбор панелей и аудитории:</span> Мы подбираем подходящие панели
                респондентов или комбинацию нескольких источников, оцениваем доступный объём аудитории и возможные
                ограничения по критериям.
            </p>
            <p>
                <span className={css.bold}>3. Расчёт стоимости и сроков:</span> Вы получаете расчёт бюджета и сроков
                проведения опроса. Стоимость формируется прозрачно и зависит только от параметров исследования.
            </p>
            <p>
                <span className={css.bold}>4. Запуск и сбор ответов:</span> После согласования условий начинается сбор
                ответов. Приглашения рассылаются через выбранные панели, а заполненные анкеты автоматически поступают в
                систему Тестограф.
            </p>
            <p>
                <span className={css.bold}>5. Получение результатов:</span> Как только нужное количество ответов
                собрано, сбор останавливается. Данные сразу доступны для анализа и выгрузки (Excel, CSV и другие
                форматы). В зависимости от сложности аудитории сбор может занимать от нескольких часов до нескольких
                дней. Для массовых потребительских сегментов ответы часто собираются в течение 1–2 дней.
            </p>
            <p className={css.bold}>Стоимость и модель оплаты</p>
            <p>Стоимость опроса зависит от:</p>
            <p>- количества респондентов,</p>
            <p>- сложности и редкости целевой аудитории,</p>
            <p>- длины анкеты,</p>
            <p>- срочности сбора данных.</p>
            <p>
                Используется модель оплаты за полученные ответы — вы платите только за фактически заполненные анкеты.
                Вознаграждение респондентам и комиссия панелей уже включены в расчёт. Если по итогам сбора было получено
                меньше ответов, чем планировалось (например, из-за ограниченности аудитории), неиспользованные средства
                не списываются и могут быть учтены при дальнейшем планировании.
            </p>

            <p className={css.bold}>Требования к содержанию опросов</p>
            <p>Перед запуском все анкеты проходят модерацию. Основные требования:</p>
            <p>
                - <span className={css.bold}>Запрещённые темы и содержание:</span> Недопустимы ненормативная лексика,
                оскорбительные высказывания, пропаганда экстремизма, насилия, порнография или иные запрещенные
                законодательством темы. Также не допускаются опросы, которые используются для рекламы конкретных
                товаров/услуг либо сбора персональных данных респондентов (например, контактов).
            </p>
            <p>
                - <span className={css.bold}>Рекомендуемая длина анкеты:</span> До 70 вопросов. Оптимально — 10–30
                вопросов, чтобы сохранить мотивацию респондентов и качество данных.
            </p>
            <p>
                - <span className={css.bold}>Корректность формулировок:</span> Вопросы должны быть понятными,
                нейтральными и не наводящими. Ошибки и двусмысленные формулировки могут снижать качество ответов.
            </p>
            <p className={css.bold}>Преимущества работы с панелями через Тестограф</p>
            <p>
                - <span className={css.bold}>Подбор аудитории под задачу:</span> Мы подбираем панели и источники
                респондентов под требования исследования, а не наоборот.
            </p>
            <p>
                - <span className={css.bold}>Быстрый старт:</span> Нет необходимости самостоятельно искать подрядчиков и
                договариваться с панелями — процесс организован через единую точку входа.
            </p>
            <p>
                - <span className={css.bold}>Гибкая сегментация:</span> Доступен подбор аудитории по
                социально-демографическим, экономическим, потребительским и поведенческим параметрам.
            </p>
            <p>
                - <span className={css.bold}>Прозрачный бюджет:</span> Стоимость известна до запуска и не содержит
                скрытых доплат.
            </p>
            <p className={css.bold}>Целевая аудитория и фильтрация</p>
            <p>В зависимости от выбранных панелей доступны фильтры по следующим категориям:</p>
            <p>- социально-демографические параметры (возраст, пол, регион, тип населённого пункта);</p>
            <p>- экономические характеристики (род деятельности, доход, сфера работы);</p>
            <p>- потребительские признаки (владение товарами и сервисами);</p>
            <p>- интересы и поведенческие характеристики.</p>
            <p>
                Для массовых B2C-исследований такие панели закрывают большинство задач. В случае узких или редких
                аудиторий проводится предварительная оценка доступности, сроков и стоимости.
            </p>
            <Script
                defer={true}
                dangerouslySetInnerHTML={{
                    __html: `
                     window.ttgrafSetEmbedParams?.({
                    id: 686703,
                    scrollToInvalid: true,
                    fixedHeaderHeight: 0,
                });
                `,
                }}
            />
        </div>
    );
};
